// Serves AVIF + WebP with responsive srcset/sizes and intrinsic dimensions
// (prevents layout shift). `base` is the asset path without extension, e.g.
// "/assets/03-capabilities-hero". Derivatives -640/-960/-1280/-1600 exist for
// heroes; falls back to `${base}.webp`.
const HERO_WIDTHS = [640, 960, 1280, 1600];
const MOBILE_WIDTHS = [640, 900];

export function ResponsiveImage({
  base,
  alt,
  className = "",
  sizes = "(max-width: 1023px) 100vw, 56vw",
  width = 1600,
  height = 900,
  eager = false,
  priority = false,
  style,
  mobile = false,
}) {
  const widths = mobile ? MOBILE_WIDTHS : HERO_WIDTHS;
  const srcset = (ext) => widths.map((w) => `${base}-${w}.${ext} ${w}w`).join(", ");
  return (
    <picture>
      <source type="image/avif" srcSet={srcset("avif")} sizes={sizes} />
      <source type="image/webp" srcSet={srcset("webp")} sizes={sizes} />
      <img
        src={`${base}.webp`}
        alt={alt}
        width={width}
        height={height}
        loading={eager ? "eager" : "lazy"}
        decoding="async"
        {...(priority ? { fetchPriority: "high" } : {})}
        className={className}
        style={style}
      />
    </picture>
  );
}
